export default __webpack_public_path__ + "static/media/ChevronRight.0766218f.svg";